export default "__VITE_ASSET__vPvXtgyz__"